<script>
import { ref, onMounted } from 'vue'

export default {

  setup() {

    const vk = ref(
      `https://vk.com/share.php?url=`
    )
    const fb = ref(
      `https://www.facebook.com/sharer.php?src=sp&u=`
    )
    const viber = ref(
      `viber://forward?text=`
    )

    const whatsapp = ref(
      `https://api.whatsapp.com/send?text=`
    )
    const telegram = ref(`https://telegram.me/share/url?url=`)

    onMounted(() => {
      vk.value += window.location.href
      fb.value += window.location.href
      viber.value += window.location.href
      whatsapp.value += window.location.href
      telegram.value += window.location.href
    })

    return { vk, fb, viber, whatsapp, telegram }
  }
}
</script>

<template>
  <div class="w-full flex flex-col space-y-4">
    <h6>Поделиться в соцсетях</h6>
    <div class="w-full flex flex-row space-x-7">
      <a :href="vk">
        <r-icon class="w-10 h-10" icon="vk-canonical" />
      </a>
      <a :href="fb">
        <r-icon class="w-10 h-10" icon="facebook-canonical" />
      </a>
      <!-- <a :href="fb">
        <r-icon
          class="w-10 h-10"
         
          icon="odnoklassniki-canonical"
        />
      </a>-->
      <a :href="viber">
        <r-icon class="w-10 h-10" icon="viber-canonical" />
      </a>
      <a :href="whatsapp">
        <r-icon class="w-10 h-10" icon="whatsapp-canonical" />
      </a>
      <!-- <a :href="telegram">
        <r-icon class="w-10 h-10" icon="facebook-canonical" />
      </a>-->
    </div>
  </div>
</template>
